import YModal from './Modal';

export { YModal };
export default YModal;
